import { useAdministrativeContext } from '../../../../../pages/administrativePanel/administrativePanelContext'
import { useState, useEffect } from 'react'
import { api } from '../../../../../services/api'
import { FormatMoney } from '../../formatMoney'
import { SpaceLoader } from '../../../../loaders/spaceLoader'
import { toast } from 'react-toastify'
import { 
    FaShoppingBag, 
    FaCashRegister, 
    FaCartPlus,
    FaMotorcycle,
    FaTrash
} from 'react-icons/fa'

import { Container, Card } from './style'


export function OrdersSummary() {
    const { listBusinessToFilter } = useAdministrativeContext()
    const [ordersDatas, setOrdersDatas] = useState(null)
    const [isOrdersDatasLoading, setIsOrdersDatasLoading] = useState(true)


    useEffect(() => {
        async function fetchData() {
            try{
                await api.get(`/getOrdersSummary/?business=${listBusinessToFilter}`)
                .then((response) => {
                        setOrdersDatas(response.data)
                })
                setIsOrdersDatasLoading(false)
            }catch{
                toast.error('Algo deu errado')
            }
        }
        fetchData()
    }, [listBusinessToFilter])


    return(
        <Container>
            <Card 
                background="#F0F1F5"
                color="#535354"
            >
                <strong>
                    <FaCashRegister />
                    TOTAL
                </strong>
                {
                    isOrdersDatasLoading ? <SpaceLoader colorLoader="#535354"/> : 
                    <>
                        <span>{ordersDatas.allOrdersQuantity}</span>
                        <FormatMoney value={ordersDatas.allOrdersTotal}/>
                    </>
                }
            </Card>


            <Card 
                background="#e05f59"
            >
                <strong>
                    <FaCartPlus />
                    ABERTOS
                </strong>
                {
                    isOrdersDatasLoading ? <SpaceLoader colorLoader="#FFF"/> : 
                    <>
                        <span>{ordersDatas.openedOrdersQuantity}</span>
                        <FormatMoney value={ordersDatas.openedOrdersTotal}/>
                    </>
                }
            </Card>


            <Card 
                background="#4A007A"
            >
                <strong>
                    <FaMotorcycle />
                    EM ENTREGA
                </strong>
                {
                    isOrdersDatasLoading ? <SpaceLoader colorLoader="#FFF"/> : 
                    <>
                        <span>{ordersDatas.deliveryingOrdersQuantity}</span>
                        <FormatMoney value={ordersDatas.deliveryingOrdersTotal}/>
                    </>
                }
            </Card>

            <Card
                background="#F0E68C"
                color="#535354"
            >
                <strong>
                    <FaTrash/>
                    Rejeitados
                </strong>
                {
                    isOrdersDatasLoading ? <SpaceLoader colorLoader="#FFF"/> : 
                    <>
                        <span>{ordersDatas.rejectOrdersQuantity}</span>
                        <FormatMoney value={ordersDatas.rejectOrdersTotal}/>
                    </>
                }
            </Card>


            <Card 
                background="#2e9699"
            >
                <strong>
                    <FaShoppingBag />
                    FINALIZADOS
                </strong>
                {
                    isOrdersDatasLoading ? <SpaceLoader colorLoader="#FFF"/> : 
                    <>
                        <span>{ordersDatas.finishedOrdersQuantity}</span>
                        <FormatMoney value={ordersDatas.finishedOrdersTotal}/>
                    </>
                }
            </Card>
        </Container>
    )
}
